const loadState = () => {
    try {
      const serializedState = localStorage.getItem('state')
      if (serializedState === null) {
        return {
          user: null,
          token: null,
          policies: [],
          isLogged: false,
          sector: null,
          filter_facility: '',
          SET_PERMISSION_USER: '',
          company: '1',
          countries: [],
          states: [],
          districts: [],
          cities: [],
          contactTypes: [],
          customers: [],
          jobCreationBasicDetails: {},
          containerTypes: [],
          otherRequests: [],
          dropPicks: [],
          editCustomer: {},
          gpsLocations: [],
          vehicleTypes: [],
          loadingLocations: [],
          supplierNegotiationChargeTypes: [],
          supplierNegotiationCurrencies: [],
          supplierNegotiationChargeModes: [],
          flagReasons: [],
          chargeTypes: [],
          gpsVehicles: [],
          roles: [],
        }
      }
      return JSON.parse(serializedState)
    } catch (e) {
      return undefined
    }
  }
  
  const saveState = (state) => {
    try {
      const serializedState = JSON.stringify(state)
      localStorage.setItem('state', serializedState)
    } catch (e) {
      console.log(e)
      // Ignore write errors;
    }
  }
  
  export const initialState = loadState()
  
  const reducer = (state, action) => {
    switch (action.type) {
      case 'SET_COMPANY':
        saveState({
          ...state,
          company: action.company,
        })
  
        return {
          ...state,
          company: action.company,
        }
  
      case 'SET_COUNRTIES':
        saveState({
          ...state,
          countries: action.countries,
        })
  
        return {
          ...state,
          countries: action.countries,
        }
  
      case 'SET_STATES':
        saveState({
          ...state,
          states: action.states,
        })
  
        return {
          ...state,
          states: action.states,
        }
  
      case 'SET_DISTRICTS':
        saveState({
          ...state,
          districts: action.districts,
        })
  
        return {
          ...state,
          districts: action.districts,
        }
  
      case 'SET_CITIES':
        saveState({
          ...state,
          cities: action.cities,
        })
  
        return {
          ...state,
          cities: action.cities,
        }
  
      case 'SET_CONTACT_TYPES':
        saveState({
          ...state,
          contactTypes: action.contactTypes,
        })
  
        return {
          ...state,
          contactTypes: action.contactTypes,
        }
  
      case 'SET_CUSTOMERS':
        saveState({
          ...state,
          customers: action.customers,
        })
  
        return {
          ...state,
          customers: action.customers,
        }
      case 'SET_JOB_CREATION_BASIC_DETAILS':
        saveState({
          ...state,
          jobCreationBasicDetails: action.jobCreationBasicDetails,
        })
  
        return {
          ...state,
          jobCreationBasicDetails: action.jobCreationBasicDetails,
        }
  
      case 'SET_CONTAINER_TYPES':
        saveState({
          ...state,
          containerTypes: action.containerTypes,
        })
  
        return {
          ...state,
          containerTypes: action.containerTypes,
        }
  
      case 'SET_OTHER_REQUESTS':
        saveState({
          ...state,
          otherRequests: action.otherRequests,
        })
  
        return {
          ...state,
          otherRequests: action.otherRequests,
        }
  
      case 'SET_DROP_PICKS':
        saveState({
          ...state,
          dropPicks: action.dropPicks,
        })
  
        return {
          ...state,
          dropPicks: action.dropPicks,
        }
  
      case 'SET_GPS_LOCATIONS':
        saveState({
          ...state,
          gpsLocations: action.gpsLocations,
        })
  
        return {
          ...state,
          gpsLocations: action.gpsLocations,
        }
  
      case 'SET_VEHICLE_TYPES':
        saveState({
          ...state,
          vehicleTypes: action.vehicleTypes,
        })
  
        return {
          ...state,
          vehicleTypes: action.vehicleTypes,
        }
  
      case 'SET_LOADING_LOCATIONS':
        saveState({
          ...state,
          loadingLocations: action.loadingLocations,
        })
  
        return {
          ...state,
          loadingLocations: action.loadingLocations,
        }
  
      case 'SET_SUPPLIER_NEGOTIATION_CHARGE_TYPE':
        saveState({
          ...state,
          supplierNegotiationChargeTypes: action.supplierNegotiationChargeTypes,
        })
  
        return {
          ...state,
          supplierNegotiationChargeTypes: action.supplierNegotiationChargeTypes,
        }
  
      case 'SET_SUPPLIER_NEGOTIATION_CURRENCY':
        saveState({
          ...state,
          supplierNegotiationCurrencies: action.supplierNegotiationCurrencies,
        })
  
        return {
          ...state,
          supplierNegotiationCurrencies: action.supplierNegotiationCurrencies,
        }
  
      case 'SET_SUPPLIER_NEGOTIATION_CHARGE_MODE':
        saveState({
          ...state,
          supplierNegotiationChargeModes: action.supplierNegotiationChargeModes,
        })
  
        return {
          ...state,
          supplierNegotiationChargeModes: action.supplierNegotiationChargeModes,
        }
  
      case 'SET_FLAG_REASONS':
        saveState({
          ...state,
          flagReasons: action.flagReasons,
        })
  
        return {
          ...state,
          flagReasons: action.flagReasons,
        }
  
      case 'SET_GPS_VEHICLES':
        saveState({
          ...state,
          gpsVehicles: action.gpsVehicles,
        })
  
        return {
          ...state,
          gpsVehicles: action.gpsVehicles,
        }
  
      case 'SET_CHARGE_TYPE':
        saveState({
          ...state,
          chargeTypes: action.chargeTypes,
        })
  
        return {
          ...state,
          chargeTypes: action.chargeTypes,
        }
  
      case 'SET_EDIT_CUSTOMER':
        saveState({
          ...state,
          editCustomer: action.editCustomer,
        })
  
        return {
          ...state,
          editCustomer: action.editCustomer,
        }
  
      case 'SET_USER':
        return {
          ...state,
          user: action.user,
        }
  
      case 'SET_FILTER_FACILITY':
        return {
          ...state,
          filter_facility: action.filter_facility,
        }
      case 'SET_PERMISSION_USER':
        return {
          ...state,
          SET_PERMISSION_USER: action.SET_PERMISSION_USER,
        }
      case 'SET_TOKEN':
        saveState({
          ...state,
          token: action.token,
        })
        return {
          ...state,
          token: action.token,
        }
      case 'SET_POLICIES':
        saveState({
          ...state,
          policies: action.policies,
        })
        return {
          ...state,
          policies: action.policies,
        }
      case 'SET_SECTOR':
        saveState({
          ...state,
          sector: action.sector,
        })
        return {
          ...state,
          sector: action.sector,
        }
      case 'SET_ROLES':
        saveState({
          ...state,
          roles: action.roles,
        })
  
        return {
          ...state,
          roles: action.roles,
        }
      case 'RESET_STATE':
        saveState(initialState) // Save the initialState to localStorage
        return initialState // Return the initialState
      default:
        return state
    }
  }
  
  export default reducer
  